import React, { PropTypes } from 'react';
import SelectField from 'material-ui/SelectField';
import {MenuItem} from 'material-ui/Menu';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import ErrorContainer from '../../form/ErrorContainer';
import ParticipantNew from '../ParticipantsNew';

class ParticipantsSelect extends React.Component {
  static propTypes = {
    items: PropTypes.array,
    value: PropTypes.string,
    style: PropTypes.object,
    fetch: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
  };

  state = {
    addNew: false
  };

  componentWillMount() {
    this.props.fetch()
  }

  addParticipant() {
    this._renderedModalComponent = React.createElement(ParticipantNew, {
      onAdd: this.addItem,
      goIndex: ()=> this.closeAddParticipant()
    });
    this.setState({addNew: true});
  }

  closeAddParticipant() {
    delete this._renderedModalComponent;
    this.setState({addNew: false});
  }

  addItem = (item) => {
    this.props.onChange(item.id);
  };

  render() {
    let {
          style={},
          value,
          onChange,
          name,
          label,
          items
        } = this.props;

    let id = `ParticipantsSelect_${name}`;

    if(items.length > 0) {
      return (
        <ErrorContainer id={id} displayLabel={false} style={style} {...this.props}>
          <div style={{display: 'flex',alignItems: 'flex-end'}}>
          <SelectField
            id={id}
            style={{display: 'inline-block'}}
            value={value}
            onChange={(event, index, value) => onChange(value)}
            floatingLabelText={`${label} *`}
            fullWidth={true}
          >
            {items.map((item, index) => (
              <MenuItem
                key={index}
                value={item.id}
                primaryText={item.name}
              />
            ))}
          </SelectField>
          {this._renderAddButton()}
          </div>
        </ErrorContainer>
      );
    } else {
      return (
        <div style={Object.assign({marginTop: 16}, style)}>
          There is no Participants
          {this._renderAddButton()}
        </div>
      );
    }
  }

  _renderAddButton() {

    let { addNew } = this.state;
    return (
      <span>
        <IconButton tabIndex={-1}
                    style={{display: 'inline-block'}}
                    onClick={() => this.addParticipant()}>
            <FontIcon className="material-icons">add</FontIcon>
          </IconButton>
        { addNew ? this._renderedModalComponent : null }
      </span>
    );
  }
}

export default ParticipantsSelect;




// WEBPACK FOOTER //
// ./src/components/Participants/ParticipantsSelect/ParticipantsSelect.jsx